import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { UserService } from "../authentication/user.service";
import { Role } from "../models/enums/roles";

@Injectable({
    providedIn: 'root'
})
export class AdminGuardService  {
    constructor(
        private user: UserService,
        private router: Router
    ) { }

    async canActivate(): Promise<boolean> {
        await this.user.updateCurrentUser();
        if (this.user.currentUser?.role === Role.admin)
            return true;
        this.router.navigate(['/authentication']);
        return false;
    }
}
